import { render, staticRenderFns } from "./CommonTopicHeader.vue?vue&type=template&id=393471d8&"
import script from "./CommonTopicHeader.vue?vue&type=script&lang=ts&"
export * from "./CommonTopicHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports